import { debounce } from "lodash";

function setHeroMargin() {
  var hero = document.querySelector(".hero-under-header");
  if (hero) {
    document.querySelector("header").classList.add("with-hero-under-header");
    var rect = hero.getBoundingClientRect();
    var scrollTop = window.scrollY;
    // extra 2px for issue with google chrome
    var margin = rect.top + scrollTop + 2;
    hero.style.marginTop = `-${margin}px`;
  }
}

// set margin of hero to size of header (including promo bar)
document.addEventListener("DOMContentLoaded", (event) => {
  setHeroMargin();
});

document.addEventListener(
  "resize",
  debounce(function () {
    setHeroMargin();
  }, 400),
);
